import { Register } from "../../components/Pages/Register";

export const RegisterPage = () => {
  return <Register />;
};
